export const contactsData = {
    email: 'sachidanand.kpradhan@gmail.com',
    phone: '+917992317311',
    address: 'Bangalore, India',

    sheetAPI: ''
}